import { VisaCardBrandIcon, MastercardCardBrandIcon, AmericanExpressCardBrandIcon } from 'components/Icons';

export const cardBrandMap: PartialRecord<string, JSX.Element> = {
  visa: <VisaCardBrandIcon />,
  mastercard: <MastercardCardBrandIcon />,
  amex: <AmericanExpressCardBrandIcon />,
  'american express': <AmericanExpressCardBrandIcon />,
};
